import React, { useState, useMemo } from 'react';

export default function TopicPicker({ topics, selectedIds, onToggle }) {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    if (!query) return topics;
    const q = query.toLowerCase();
    return topics.filter(
      (t) =>
        (t.subtopic || '').toLowerCase().includes(q) ||
        (t.general_topic || '').toLowerCase().includes(q) ||
        (t.subject_area || '').toLowerCase().includes(q)
    );
  }, [topics, query]);

  const grouped = useMemo(() => {
    const groups = {};
    filtered.forEach((t) => {
      const sa = t.subject_area || 'Other';
      if (!groups[sa]) groups[sa] = [];
      groups[sa].push(t);
    });
    return groups;
  }, [filtered]);

  const selectedCount = selectedIds ? selectedIds.size : 0;

  return (
    <div>
      <input
        type="text"
        placeholder="Search topics..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="w-full border border-border-soft rounded-r-md px-sp-4 py-sp-3 text-sm font-sans mb-sp-4 outline-none focus:border-accent bg-bg-card text-text-primary placeholder:text-text-muted"
      />

      <div className="border border-border-soft rounded-r-lg overflow-hidden mb-sp-3 max-h-96 overflow-y-auto">
        {Object.keys(grouped).length === 0 ? (
          <div className="px-sp-4 py-sp-6 text-sm text-text-muted text-center">
            No topics with questions found.
          </div>
        ) : (
          Object.entries(grouped).map(([sa, items]) => (
            <div key={sa}>
              <div className="px-sp-4 py-sp-3 bg-bg-surface text-xs font-semibold text-text-primary border-b border-border-soft">
                {sa}
              </div>
              {items.map((t) => {
                const isSelected = selectedIds && selectedIds.has(t.topic_id);
                return (
                  <label
                    key={t.topic_id}
                    className="px-sp-4 py-sp-3 flex items-center gap-sp-3 border-b border-border-soft last:border-b-0 cursor-pointer hover:bg-bg-page transition-colors"
                  >
                    <input
                      type="checkbox"
                      checked={!!isSelected}
                      onChange={() => onToggle(t.topic_id)}
                      className="w-4 h-4 accent-accent cursor-pointer flex-shrink-0"
                    />
                    <span className="text-sm text-text-primary flex-1">{t.subtopic}</span>
                    <span className="text-xs text-text-muted font-medium">
                      {t.question_count} Qs
                    </span>
                  </label>
                );
              })}
            </div>
          ))
        )}
      </div>

      {selectedCount > 0 && (
        <p className="text-sm text-text-muted mb-sp-2">
          {selectedCount} topic{selectedCount === 1 ? '' : 's'} selected
        </p>
      )}
    </div>
  );
}
